import React, { useState } from 'react'
import AppSidebar from '../../components/AppSidebar'
import AppHeader from '../../components/AppHeader'
import PageHeader from '../../components/PageHeader'
// import FieldVisitService from '../../services/FieldVisitService'
import CustomersService from '../../services/CustomersService'
import { toast, ToastContainer } from 'react-toastify'
import { Controller, useForm } from 'react-hook-form'
import AsyncCreatableSelect from 'react-select/async-creatable';
import CreateCustomer from './modal/CreateCustomer'
import UploadFile from '../../components/UploadFile'

const CreateFieldVisit = () => {
    const { register, handleSubmit, control, formState: { errors }, setValue } = useForm()
    const [loading, setLoading] = useState(false)
    const [selectedCustomer, setSelectedCustomer] = useState(null)
    const [showCustomerModal, setShowCustomerModal] = useState(false)

    const fetchCustomerOptions = async (inputValue) => {
        try {
            if (!inputValue) return [];
            const response = await CustomersService.listAll(inputValue);
            if (response.status === 200 && response.data.success) {
                return response.data.data.map(customer => ({
                    value: customer.id,
                    label: customer.company
                }));
            }
        } catch (error) {
            console.error("Error fetching customer options:", error);
        }
        return []; // ensure fallback
    };

    const createNewCustomer = async (data) => {
        setShowCustomerModal(true);
    }

    const onFieldVisitSubmit = (data) => {
        setLoading(true)
        console.log("Form data submitted:", data)
    }
    const onCustomerSubmit = async (data) => {
        try {
            const response = await CustomersService.create({ data });
            if (response.status === 201) {
                fetchCustomerOptions();
                toast.success(response?.data?.message);
                setShowCustomerModal(false);
            }
        } catch (error) {
            console.error("Error creating new customer:", error);
        }
    }
    const handleFileUpload = (urls) => {
        console.log("Uploaded URLs:", urls)
    }
    return (
        <>
            <AppSidebar />
            <div className="main-content">
                <AppHeader />
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <PageHeader
                                title="Create Field Visit"
                                button_label1="Back"
                                link_to1="/field-visits"
                                className1="btn btn-sm btn-primary"
                            />
                            <div className="row">
                                <div className="col-12 col-xl-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <form onSubmit={handleSubmit(onFieldVisitSubmit)}>
                                                <div className="mb-3">
                                                    <label htmlFor="customer_id" className="form-label">Customer</label>
                                                    <Controller
                                                        name="customer_id"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <AsyncCreatableSelect
                                                                {...field}
                                                                cacheOptions
                                                                isClearable
                                                                isSearchable
                                                                loadOptions={(inputValue) => fetchCustomerOptions(inputValue)}                                                                onChange={(selectedOption) => {
                                                                    field.onChange(selectedOption);
                                                                    setSelectedCustomer(selectedOption);
                                                                }}
                                                                value={selectedCustomer}
                                                                onCreateOption={(inputValue) => {
                                                                    return createNewCustomer(inputValue);
                                                                }}
                                                            />
                                                        )}
                                                    />

                                                    {errors.name && (
                                                        <p className="text-danger">{errors.name.message}</p>
                                                    )}
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label">Visit Date</label>
                                                    <input type="date" className="form-control" {...register("visit_date")} />
                                                    {errors.visit_date && (
                                                        <p className="text-danger">{errors.visit_date?.message}</p>
                                                    )}
                                                </div>
                                                <div className="mb-3">
                                                    <label className="form-label">Purpose</label>
                                                    <textarea className="form-control" {...register("purpose")} />
                                                    {errors.purpose && (
                                                        <p className="text-danger">{errors.purpose?.message}</p>
                                                    )}
                                                </div>
                                                <div className="mb-3">
                                                    <div className="col">
                                                        <label className="form-label">Images</label>
                                                        <UploadFile folderName="field-visit" onFileUpload={handleFileUpload} />
                                                    </div>
                                                </div>
                                                <div className="text-end">
                                                    <button type="submit" className="btn btn-primary" disabled={loading}>
                                                        {loading ? 'Creating...' : 'Create'}
                                                    </button>
                                                    {loading && (
                                                        <div className="mt-3">
                                                            <div className="spinner-border text-primary" role="status">
                                                                <span className="sr-only">Loading...</span>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />

            {showCustomerModal &&
                <CreateCustomer
                    show={showCustomerModal}
                    onClose={() => setShowCustomerModal(false)}
                    onSubmit={onCustomerSubmit}
                    handleSubmit={handleSubmit}
                    control={control}
                    errors={errors}
                    register={register}
                    setValue={setValue}
                />
            }
        </>
    )
}

export default CreateFieldVisit